import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import {
	Button,
	Card,
	CardBody,
	Col,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
} from "reactstrap";
import * as Yup from "yup";
import { ReactComponent as CrossIcon } from "../../assets/utils/images/svgs/Cross.svg";
import { ReactComponent as PenIcon } from "../../assets/utils/images/svgs/editPen.svg";
import { ReactComponent as EyeIcon } from "../../assets/utils/images/svgs/Eye-icon.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { BsCheckCircle, BsQuestionCircle } from "react-icons/bs";
import axiosInstance from "Api";
import { toast } from "react-toastify";
import TwoFAModal from '../../Components/Modal/TwoFAModal'

import AdminService from "Api/Admin";
import Loader from 'react-loaders';
import SweetAlert from "react-bootstrap-sweetalert";

const DisplayingErrorMessagesSchema = Yup.object().shape({
	password_current: Yup.string()
		.trim()
		.required('Huidig wachtwoord is vereist')
		.test(
			'Password Correct',
			'Wachtwoord komt niet overeen met het huidige wachtwoord',
			function (value) {
				if (!value || value.length < 8) return false;
				return new Promise((resolve) => {
					axiosInstance.post('users/validate', { password_current: value }).then(res => {
						resolve(res.data.status === 'success');
					}).catch(() => {
						resolve(false);
					});
				});
			}
		),
	password: Yup.string()
		.required('Wachtwoord is verplicht')
		.min(8, "Wachtwoord moet minimaal 8 tekens bevatten")
		.max(50, "Het wachtwoord mag maximaal 50 tekens bevatten")
		.matches(/^\S*$/, "Wachtwoord mag geen spaties bevatten")
		.matches(/[A-Za-z]+/, "Gebruik minimaal 1 of meer hoofdletters en kleine letters a-z en A-Z")
		.matches(/[0-9]+/, "Wachtwoord moet minimaal 1 cijfers bevatten")
		.matches(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]+/, "Wachtwoord moet minimaal 1 speciaal teken bevatten !@#$%^&*()_+")
		.test(
			'Different from current password',
			'Het wachtwoord moet verschillen van het huidige wachtwoord',
			function (value) {
				return value !== this.parent.password_current;
			}
		),
	password_confirmation: Yup.string()
		.required('Wachtwoordbevestiging is vereist')
		.oneOf([Yup.ref('password'), null], 'Wachtwoorden komen niet overeen')
});

const validationSchemaForUser = Yup.object().shape({
	vUserName: Yup.string()
		.required("Gebruikersnaam is verplicht")
		.min(3, "Minimaal 3 letters vereist")
		.max(50, "Maximaal 50 letters toegestaan")
		.matches(/^[A-Za-z\s]+$/, "Alleen letters toegestaan, geen cijfers")
});


const LoginDetails = ({ data, fetchProfileData }) => {
	const profile = data?.profileList;
	const [usernameModal, setUsernameModal] = useState(false);
	const [passwordModal, setPasswordModal] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [isShowAlertModalOpen, setIsShowALertModalOpen] = useState(false)
	const [showOTPModal, setShowOTPModal] = useState(false);
	const [showQRModal, setShowQRModal] = useState(false);
	const [otp, setOtp] = useState('');
	const [qrCodeSVG, setQrCodeSVG] = useState('');
	const [recoveryCode, setRecoveryCode] = useState(null);
	const [verifyType, setVerifyType] = useState(null);
	const [enableVerfication, setEnableVerification] = useState(null)
	const [qrError, setQrError] = useState('');
	const [userData, setUserData] = useState(profile);
	const [showCurrentPassword, setShowCurrentPassword] = useState(false);
	const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [showImpersonateClickModal, setShowImpersonateClickModal] = useState(false);
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);
	const [error, setError] = useState(false);
	const [emailSent, setEmailSent] = useState(false);
	const [timer, setTimer] = useState(300);

	// Toggles
	const toggleUsernameModal = () => setUsernameModal(!usernameModal);
	const togglePasswordModal = () => setPasswordModal(!passwordModal);
	const toggleModal = () => {
		setModalOpen(!modalOpen)
	};
	useEffect(() => {
		setUserData(profile);
	}, [profile]);

	const toggleTwoFAModal = () => {
		setShowQRModal(true)
		generateQR(profile.iAdminId);
		if (profile?.twoFactor === 'email') {
			handleLink();
		}

	}

	const handleTwoFAClick = () => {
		if (data?.bTwoFaEnabled === false) {
			toast.error("U kunt 2FA niet wijzigen. Neem contact op met de beheerder.");
			return;
		}

		if (profile?.impersonate === 1 && profile?.isEnabled === 0) {
			setShowImpersonateClickModal(true);
			return;
		}
		if (profile?.impersonate === 1 && profile?.isEnabled === 1) {
			setIsShowALertModalOpen(true);
			return;
		}
		if (profile?.isEnabled === 1 && profile?.impersonate === 0) {
			handleOTP();
		} else {
			toggleTwoFAModal();
		}
	};

	const generateQR = (iAdminId) => {
		setIsButtonDisabled(true);
		setEmailSent(false);
		setQrCodeSVG('');
		setQrError('');
		AdminService.getQR(iAdminId)
			.then((response) => {
				if (response?.data?.status) {
					setQrCodeSVG(response?.data.qr);
					setQrError('');
					if (response?.data?.verification_type) {
						setEnableVerification(response.data.verification_type);
					}
				} else {
					setQrCodeSVG('');
					setQrError("QR-generatie mislukt. Probeer het opnieuw!");
				}
			})
			.catch((error) => {
				console.error(error);
				setQrCodeSVG('');
				setQrError('Er is iets misgegaan. Probeer het alstublieft opnieuw.');
			})
			.finally(() => {
				setIsButtonDisabled(false);
			})
	}

	const enableTwoFactorAuthentication = (values, setFieldError) => {
		setIsButtonDisabled(true);
		const verifyType =
			enableVerfication ||
			((profile?.isEnabled === 1 && data?.twoFactor === "email") ||
				(profile?.isEnabled === 0 && !data?.twoFactor)
				? "auth"
				: "mail");
		const payload = { verification_code: values.verification_code, iEnable: 1, verification_type: verifyType };

		AdminService.postQRCode(payload)
			.then((response) => {
				if (response?.data?.status) {
					const codes = response?.data?.recoveryCodes;
					if (response.data.verification_way === 'auth') {
						setVerifyType('auth');
						setShowOTPModal(true)
						return;
					}
					if (!codes || codes.length === 0) {
						setShowQRModal(false);
						fetchProfileData();
					} else {

						setRecoveryCode(codes);
					}

					setQrCodeSVG('');

				} else {
					setFieldError("verification_code", "onjuiste code");
				}
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				setIsButtonDisabled(false);
			})
	}

	const toggle2faModal = () => {
		setEnableVerification(null);
		setShowQRModal(!showQRModal);
		setQrError('');
		setRecoveryCode(null);
		setVerifyType(null);
	}
	const open2FAModal = () => {
		if (profile?.impersonate) {
			setIsShowALertModalOpen(false);
			setShowOTPModal(false);
			disable2FA();


		} else {
			disable2FA();
		}
	}

	const toggleALertModal = () => {
		setIsShowALertModalOpen(!isShowAlertModalOpen)
	}


	// const handleOTPSubmit = (otp) => {
	// 	setError("")
	// 	if (data?.twoFactor === 'email') {
	// 		VerifyEmailCode(otp);
	// 	} else {
	// 		disable2FA(otp);
	// 	}
	// };
	const handleOTPSubmit = (otp) => {
		setError("");
		if (verifyType === 1) {
			VerifyEmailCode(otp);
		} else {
			disable2FA(otp);
		}
	};
	const validationSchema = Yup.object().shape({
		verification_code: Yup.string().required('Voer qrcode in'),
	});

	const handleOTP = () => {
		setVerifyType(null);
		setShowOTPModal(true);

	}

	const VerifyEmailCode = (otp) => {

		setError("");
		data = {
			verification_code: otp
		}
		AdminService.VerifyDisableEmail(data)
			.then((response) => {
				setRecoveryCode("")
				if (response?.data?.status) {
					deleteCookie("rememberToken");
					localStorage.removeItem("otpTimerEnd");
					setEmailSent(false);

					fetchProfileData();
					setVerifyType(null);
					setShowOTPModal(false);
				}
				else {
					setError("onjuiste code")
				}
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				setOtp('');

			});
	}
	const formatTime = (seconds) => {
		const m = Math.floor(seconds / 60);
		const s = seconds % 60;
		return `${m}:${s < 10 ? "0" : ""}${s}`;
	};

	const disable2FA = () => {
		setError(" ")
		const rememberToken = getCookie("rememberToken");

		const data = {
			rememberToken: rememberToken,
			iEnable: 0,
			...((otp !== '' || otp) && { one_time_password: otp }),
		};

		AdminService.disable2FA(data)
			.then((response) => {
				setRecoveryCode("")
				if (response?.data?.status) {
					deleteCookie("rememberToken");
					localStorage.removeItem("otpTimerEnd");
					profile?.impersonate && setIsShowALertModalOpen(false);
					fetchProfileData();
					setShowQRModal(false);
					setShowOTPModal(false);
				}
				else {
					setError("onjuiste code")
				}
			})
			.catch((error) => {
				console.error(error);
			}).finally(() => {
				setOtp('');

			});
	};

	useEffect(() => {
		const savedEndTime = localStorage.getItem("otpTimerEnd");

		if (!savedEndTime) return;

		const remaining = Math.floor((savedEndTime - Date.now()) / 1000);

		if (remaining > 0) {
			setEmailSent(true);
			setTimer(remaining);
		} else {
			localStorage.removeItem("otpTimerEnd");
			setEmailSent(false);
		}
	}, []);
	useEffect(() => {
		let interval;

		if (emailSent && timer > 0) {
			interval = setInterval(() => {
				setTimer((prev) => prev - 1);
			}, 1000);
		}

		return () => clearInterval(interval);
	}, [emailSent, timer]);

	const handleLink = (setFieldValue) => {
		AdminService.handleEmailLink().then((res) => {
			if (res.data.status) {
				setEmailSent(true);
				const verifyType = res.data.verification_type
				setEnableVerification(verifyType);
			}
		})
			.catch((error) => {
				console.error(error)
			})
	}

	const getCookie = (cookieName) => {
		const cookies = document.cookie.split("; ");
		for (let cookie of cookies) {
			const [name, value] = cookie.split("=");
			if (name === cookieName) {
				return value;
			}
		}
		return null;
	};
	const deleteCookie = (cookieName) => {
		document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure; samesite=strict`;
	};

	const callProfileData = () => {
		setShowQRModal(false);
		fetchProfileData();
	}

	return (
		<>
			<Card className="main-card gebruikers-view" style={{ height: "100%" }}>
				<CardBody className="d-flex flex-column algemeen">
					<h5 className="mb-4">Inloggegevens</h5>




					<Row className="mb-3 mt-1 d-flex justify-content-between align-items-center">
						<Col className="col-md-6 mt-0">Gebruikersnaam</Col>
						<Col className="col-md-6 d-flex justify-content-between mt-0">
							<span className="text-break">{userData?.vUserName || profile
								?.vUserName}</span>

							<span className="ms-3 svg-pointer" onClick={toggleUsernameModal}>
								<PenIcon />
							</span>
						</Col>
					</Row>


					<Row className="mb-3 mt-1 d-flex justify-content-between align-items-center">
						<Col className="col-md-6 mt-0">Wachtwoord</Col>
						<Col className="col-md-6 d-flex justify-content-between mt-0">
							<span>********</span>
							<span className="ms-3 svg-pointer" onClick={togglePasswordModal}>
								<PenIcon />
							</span>
						</Col>
					</Row>
					<Row className="mb-3 d-flex justify-content-between align-items-center">
						<Col className="col-sm-7">Two-factor-authentication</Col>
						<Col className="col-sm-2 d-flex justify-content-end">
							{(profile?.isEnabled === 1) ? (
								<BsCheckCircle color="#39A825" fontSize="18px" onClick={handleTwoFAClick} style={{ cursor: "pointer" }} />
							) : (
								<span onClick={handleTwoFAClick} className="svg-pointer">
									<CrossIcon />
								</span>
							)}
						</Col>



						<Col className="col-sm-2 d-flex align-items-center" style={{ cursor: "pointer" }} onClick={toggleModal}>
							<BsQuestionCircle color="#FFA73F" fontSize="18px" />
						</Col>
					</Row>
				</CardBody>
			</Card>


			<Modal
				isOpen={usernameModal}
				toggle={toggleUsernameModal}
				className="feedback-modal-style"
			>
				<ModalHeader toggle={toggleUsernameModal} style={{ color: "#f7941e" }}>
					Gebruikersnaam wijzigen
				</ModalHeader>

				<ModalBody>
					<Formik
						initialValues={{
							vUserName: "",
						}}
						validationSchema={validationSchemaForUser}
						onSubmit={(values, { setSubmitting }) => {
							axiosInstance.patch('users/' + profile.iAdminId, values)
								.then((response) => {
									setUserData(prev => ({
										...prev,
										vUserName: response.data?.user?.vUserName
									}));
									fetchProfileData();
									toggleUsernameModal();
								})

								.catch(() => {
									toast.error("Fout bij het bijwerken van gebruikersnaam.");
								})
								.finally(() => {
									setSubmitting(false);
								});
						}}
					>
						{({
							values,
							handleChange,
							handleBlur,
							handleSubmit,
							errors,
							touched,
							isSubmitting,
						}) => (
							<Form onSubmit={handleSubmit}>
								<FormGroup>
									<Label>Huidige gebruikersnaam</Label>
									<h6 className="mb-3">{profile?.vUserName}</h6>
								</FormGroup>

								<FormGroup>
									<Label for="clooserUn">Nieuwe gebruikersnaam</Label>
									<Input
										name="vUserName"
										type="text"
										placeholder="Nieuwe gebruikersnaam"
										value={values.vUserName}
										onChange={handleChange}
										onBlur={handleBlur}
										invalid={touched.vUserName && !!errors.vUserName}
									/>
									{touched.vUserName && errors.vUserName && (
										<div className="invalid-feedback d-block">{errors.vUserName}</div>
									)}
								</FormGroup>

								<ModalFooter className="d-flex justify-content-center gap-3 border-0">
									<Button
										className="btn-color-style"
										outline
										color="primary"
										type="submit"
										disabled={isSubmitting}
									>
										Toepassen
									</Button>

									<Button
										className="btn-color-style"
										outline
										color="primary"
										onClick={toggleUsernameModal}
									>
										Sluiten
									</Button>
								</ModalFooter>
							</Form>
						)}
					</Formik>
				</ModalBody>
			</Modal>

			<Modal
				isOpen={passwordModal}
				toggle={() => togglePasswordModal()}
				className="feedback-modal-style"
			>
				<ModalHeader toggle={togglePasswordModal} style={{ color: "#f7941e" }}>
					Wachtwoord wijzigen
				</ModalHeader>

				<ModalBody>
					<Formik
						initialValues={{
							password_current: "",
							password: "",
							password_confirmation: "",
						}}
						validateOnChange={false}
						validateOnBlur={true}
						validationSchema={DisplayingErrorMessagesSchema}
						onSubmit={(values, { setSubmitting, resetForm }) => {
							const payload = {
								password_current: values.password_current,
								password: values.password,
								password_confirmation: values.password_confirmation,
							};

							setTimeout(() => {
								axiosInstance.post("/users/change-password", payload)
									.then(() => {
										resetForm({
											values: {
												password_current: "",
												password: "",
												password_confirmation: "",
											}
										});
										fetchProfileData();
										togglePasswordModal();
									})
									.catch(() => {
										toast.error("Er is een fout opgetreden bij het bijwerken van het wachtwoord.");
									})
									.finally(() => {
										setSubmitting(false);
									});
							}, 1000);
						}}
					>
						{({
							values,
							handleChange,
							handleBlur,
							handleSubmit,
							errors,
							touched,
							isSubmitting,
							resetForm
						}) => (
							<Form onSubmit={handleSubmit}>
								<FormGroup>
									<Label for="password_current">Oud wachtwoord</Label>
									<div style={{ position: "relative" }}>
										<Input
											type={showCurrentPassword ? "text" : "password"}
											name="password_current"
											id="password_current"
											placeholder="Wachtwoord"
											value={values.password_current}
											onChange={handleChange}
											onBlur={handleBlur}
											invalid={touched.password_current && !!errors.password_current}
										/>

										<span
											onClick={() => setShowCurrentPassword(!showCurrentPassword)}
											style={{
												position: "absolute",
												right: "12px",
												top: "50%",
												transform: "translateY(-50%)",
												cursor: "pointer",
												color: "#6c757d"
											}}
										>
											<FontAwesomeIcon icon={showCurrentPassword ? faEye : faEyeSlash} />
										</span>
									</div>

									{touched.password_current && errors.password_current && (
										<div className="invalid-feedback d-block">{errors.password_current}</div>
									)}
								</FormGroup>

								<FormGroup>
									<Label for="password">Nieuw wachtwoord</Label>


									<div style={{ position: "relative" }}>
										<Input
											type={showNewPassword ? "text" : "password"}
											name="password"
											id="password"
											placeholder="Wachtwoord"
											value={values.password}
											onChange={handleChange}
											onBlur={handleBlur}
											invalid={touched.password && !!errors.password}
										/>

										<span
											onClick={() => setShowNewPassword(!showNewPassword)}
											style={{
												position: "absolute",
												right: "12px",
												top: "50%",
												transform: "translateY(-50%)",
												cursor: "pointer",
												color: "#6c757d"
											}}
										>
											<FontAwesomeIcon icon={showNewPassword ? faEye : faEyeSlash} />
										</span>
									</div>


									{touched.password && errors.password && (
										<div className="invalid-feedback d-block">{errors.password}</div>
									)}
								</FormGroup>

								<FormGroup>
									<Label for="password_confirmation">Herhaal wachtwoord</Label>
									<div style={{ position: "relative" }}>
										<Input
											type={showConfirmPassword ? "text" : "password"}
											name="password_confirmation"
											id="password_confirmation"
											placeholder="Wachtwoord"
											value={values.password_confirmation}
											onChange={handleChange}
											onBlur={handleBlur}
											invalid={touched.password_confirmation && !!errors.password_confirmation}
										/>

										<span
											onClick={() => setShowConfirmPassword(!showConfirmPassword)}
											style={{
												position: "absolute",
												right: "12px",
												top: "50%",
												transform: "translateY(-50%)",
												cursor: "pointer",
												color: "#6c757d"
											}}
										>
											<FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash} />
										</span>
									</div>
									{touched.password_confirmation && errors.password_confirmation && (
										<div className="invalid-feedback d-block">{errors.password_confirmation}</div>
									)}
								</FormGroup>

								<ModalFooter className="d-flex justify-content-center gap-3 border-0">
									<Button
										className="btn-color-style"
										outline
										color="primary"
										type="submit"
										disabled={isSubmitting}
									>
										Toepassen
									</Button>

									<Button
										className="btn-color-style"
										outline
										color="primary"
										onClick={togglePasswordModal}
									>
										Sluiten
									</Button>
								</ModalFooter>
							</Form>
						)}
					</Formik>
				</ModalBody>
			</Modal>
			<Modal isOpen={modalOpen} toggle={toggleModal} className="modal-centered contract-type-modal feedback-modal-style link-form">
				<ModalHeader toggle={toggleModal} className='px-3 mt-4'>2FA extra informatie</ModalHeader>
				<ModalBody className='text-center mt-4 mb-4'>
					<div className="fw-normal fs-6 lh-base">
						<p className="fw-bold text-start mb-0">Two-factor authentication inschakelen</p>
						<p className="text-start mb-0">Met two-factor authentication voegt u een extra beveiligingslaag toe aan uw account bij  <span
							onClick={() => window.open('https://www.clooser.nl', '_blank')}
							style={{ color: '#026094', textDecoration: 'none', cursor: 'pointer' }}
						>
							clooser.nl
						</span></p>

						<p className="text-start mb-0">1. Om gebruik te maken van two-factor authentication downloadt dat u eerst een 2FA-app zoals Google Authenticator  in de App Store of Play Store.</p>
						<p className="text-start mb-0">2. Schakel uw two-factor authentication in waarna een QR-code geladen wordt.</p>
						<p className="text-start mb-0">3. Voeg een YubiKey toe via een PIN-code</p>
						<p className="text-start mb-0">4. Als de QR-code wordt herkend zal uw authenticator-app een account toevoegen met de naam '<span
							onClick={() => window.open('https://www.clooser.nl', '_blank')}
							style={{ color: '#026094', textDecoration: 'none', cursor: 'pointer' }}
						>
							clooser.nl
						</span> <strong>(accountnaam)</strong>'. Die laat ook een verificatiecode zien welke u dient in te voeren onder het kopje <strong>'Two-factor 2fa code'</strong>  Klik vervolgens op <strong>'Toepassen'</strong> .</p>
						<p className="text-start">5. De volgende keer dat u inlogt op het controlepaneel zult u na het opgeven van uw gebruikersnaam en wachtwoord gevraagd worden om een verificatiecode op te geven die u met uw authenticator-app genereert.</p>
					</div>
				</ModalBody>
				<ModalFooter className='justify-content-center pt-3'>
					<Button color="link" className={"btn-color-style"} onClick={toggleModal}>
						Sluiten
					</Button>

				</ModalFooter>
			</Modal>
			{!profile?.impersonate ? (
				<Modal isOpen={showQRModal} className={`modal-centered two-factor-authentication-modal ${recoveryCode ? "max-width" : ''}`}>

					<ModalHeader
						toggle={recoveryCode ? callProfileData : toggle2faModal}
						className='modalHeader modal-header-color'
					>
						{recoveryCode ? "Herstelcodes" : "2FA QR-code"}
					</ModalHeader>
					<ModalBody className='modalBody-centered'>
						{recoveryCode && (
							<>
								<p className='pb-3 pt-3 head'>Dit zijn je herstelcodes</p>
								<div className="row">
									{recoveryCode.map((code, index) => (
										<div key={index} className={`col-md-6  ${index % 2 !== 0 ? "d-flex" : ""}`}>
											<p className={`fw-semibold text-monospace ${index % 2 !== 0 ? "margin-50" : ""}`} >{code}</p>
										</div>
									))}
								</div>
								<p>De herstelcode is een belangrijk onderdeel binnen de tweefactorauthenticatie. Deze unieke codes worden eenmalig verstrekt tijdens inschakelen van 2FA. Een herstelcode kan worden gebruikt in het geval je geen toegang meer hebt tot de tweefactorauthenticatie-methode. Bewaar deze herstelcodes op een veilige plaats.</p>
							</>)}

						{!recoveryCode && (
							qrCodeSVG ? (
								<div className="text-center mb-4" >
									<img
										style={{ height: '140px' }}
										src={qrCodeSVG}
										alt="QR Code"
									/>
								</div>
							) : (
								qrError === '' ? <Loader className="mx-auto w-30 mb-4" type="ball-grid-pulse" /> :
									<div className="text-danger ps-3">{qrError}</div>
							)
						)}

						{!recoveryCode && qrError === '' && (
							<Formik
								initialValues={{
									verification_code: '',
								}}
								validationSchema={validationSchema}
								onSubmit={(values, { setFieldError }) =>
									enableTwoFactorAuthentication(values, setFieldError)
								}
							>
								{({ setFieldValue, handleSubmit, values, handleBlur, errors, touched }) => (
									<Form onSubmit={handleSubmit}>
										<FormGroup className='input'>
											<Label for="2fa-code">
												Voer uw Twee-Factor (2FA) Code in
											</Label>
											<Input
												onChange={(e) => setFieldValue('verification_code', e.target.value)}
												id="2fa-code"
												name="2fa-code"
												type="text"
												value={values.verification_code}
												onBlur={handleBlur}
											/>
											{touched.verification_code && errors.verification_code && (
												<div className="invalid-feedback d-block">{errors.verification_code}</div>
											)}

										</FormGroup>




										<ModalFooter className="d-flex align-items-center justify-content-center border-bottom-0 py-4 mt-4">
											<div className="text-center">
												{data.twoFactor !== 'email' && (

													<>
														{!emailSent && (
															<p style={{ color: "#4291CF", textAlign: "center", marginBottom: "15px" }}>
																<a
																	href="#"
																	className="text-decoration-underline ms-1"
																	style={{ color: "#4291CF" }}
																	onClick={(e) => {
																		e.preventDefault();
																		handleLink(setFieldValue);
																	}}
																>
																	Ontvang uw verificatiecode per mail
																</a>
															</p>
														)}

														{emailSent && (
															<p style={{ color: "#39A825", textAlign: "center", marginBottom: "15px" }}>
																2fa e-mail verzonden. Opnieuw verzenden  {formatTime(timer)}
															</p>
														)}
													</>
												)}
											</div>

											<div>

												<Button type='submit' color="link" className={"btn-color-style"} disabled={isButtonDisabled}>
													Toepassen
												</Button>
												<Button type='submit' color="link" className={"btn-color-style"} onClick={toggle2faModal}>
													Annuleren
												</Button>
											</div>
										</ModalFooter>
									</Form>
								)}
							</Formik>
						)
						}

						{
							(recoveryCode || qrError !== '') && <ModalFooter className="d-flex align-items-center justify-content-center border-bottom-0 py-4 mt-2">
								{qrError !== '' && <Button color="link" className={"btn-color-style"} onClick={generateQR}>
									Opnieuw Proberen
								</Button>}
							</ModalFooter>
						}

					</ModalBody>
				</Modal>) : (<SweetAlert title="Weet je zeker dat je 2FA wilt uitschakelen?" show={isShowAlertModalOpen}
					type="warning"
					onCancel={toggleALertModal}
					onConfirm={open2FAModal}
					cancelBtnText="Nee"
					confirmBtnText="Ja"
					showCancel={true} />)}

			{showOTPModal && (
				<TwoFAModal
					showOTPModal={showOTPModal}
					setShow2FAModal={setShowOTPModal}
					setShowQRModal={setShowQRModal}
					showRememberMe={false}
					handleOTPSubmit={() => handleOTPSubmit(otp)}
					otp={otp}
					setOtp={setOtp}
					fetchProfileData={data}
					data={fetchProfileData}
					error={error}
					setError={setError}
					setVerifyType={setVerifyType}
					generateQR={generateQR}
					skipAutoEmailFlow={verifyType === 'auth'}

				/>
			)}
			{profile?.impersonate && !profile?.isEnabled && showImpersonateClickModal && (
				<SweetAlert
					title="Alleen ingelogde gebruikers kunnen de 2fa inschakelen."
					show={showImpersonateClickModal}
					type="warning"
					onConfirm={() => setShowImpersonateClickModal(false)}
					confirmBtnText="OK"
				/>
			)}
		</>
	);
};

export default LoginDetails;